import { withMotion } from '@hoc/withMotion';
import React from 'react';
import { FocusRing } from 'react-aria';
import { RegionSelectorStyles as S } from './RegionSelector.styles';
import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
const RegionSelector = ({ regionItems, currentRegion }) => {
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    const dropdownRef = React.useRef(null);
    const regionButtonRef = React.useRef(null);
    React.useEffect(() => {
        function handleClickOutside(event) {
            const target = event.target;
            if (dropdownRef.current &&
                !dropdownRef.current.contains(target) &&
                regionButtonRef.current &&
                !regionButtonRef.current.contains(target)) {
                setDropdownOpen(false);
            }
        }
        if (dropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownOpen]);
    // Null/undefined check for currentRegion
    if (!currentRegion) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.RegionButton, { type: "button", onClick: () => setDropdownOpen(!dropdownOpen), "data-active": dropdownOpen, ref: regionButtonRef },
                currentRegion?.img && (React.createElement(S.RegionImage, { src: currentRegion.img, alt: `${currentRegion.label} flag`, width: "24", height: "17" })),
                React.createElement(S.RegionLabel, null, currentRegion?.value),
                getSvgFromSystem(SystemIcon.ChevronDown))),
        React.createElement(S.RegionDropDown, { ref: dropdownRef, "data-active": dropdownOpen }, regionItems.map((item) => (React.createElement(S.RegionOption, { key: item.id, href: item.url, "data-is-selected": currentRegion?.value === item.value },
            React.createElement(S.RegionContent, null,
                React.createElement(S.RegionImage, { src: item.img, alt: `${item.label} flag`, width: "24", height: "17" }),
                React.createElement(S.RegionLabel, null, item.label)),
            getSvgFromSystem(SystemIcon.TickColourFlexible)))))));
};
export default withMotion(RegionSelector);
